import { MouseEvent, useCallback, useRef, useState } from 'react'
import { Swiper } from 'swiper'

export const useSliderSwipe = () => {
  const sliderRef = useRef<Swiper>(null)
  const [touchStart, setTouchStart] = useState(0)

  const handleMouseDown = useCallback((e: MouseEvent) => {
    setTouchStart(() => e.clientX)
    console.log('handleMouseDown', e)
  }, [])

  const handleMouseUp = useCallback(
    (e: MouseEvent) => {
      console.log('handleMouseUp', e)
      if (touchStart - e.clientX < 0) {
        if (sliderRef?.current?.slidePrev) {
          sliderRef.current.slidePrev()
        }
      }

      if (touchStart - e.clientX > 0) {
        if (sliderRef?.current?.slideNext) {
          sliderRef.current.slideNext()
        }
      }
    },
    [touchStart, sliderRef]
  )

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    const touch = e.touches[0]
    setTouchStart(touch.clientX)
  }

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    if (touchStart === null) return

    const touch = e.changedTouches[0]
    const endX = touch.clientX
    const deltaX = endX - touchStart

    if (deltaX < 50) {
      if (sliderRef?.current?.slideNext) {
        sliderRef.current.slideNext()
      }
    } else if (deltaX > -50) {
      if (sliderRef?.current?.slidePrev) {
        sliderRef.current.slidePrev()
      }
    }

    setTouchStart(0)
  }

  return {
    sliderRef,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchEnd,
  }
}
